// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3b013dda] .el-date-editor.el-input{width:auto!important}[data-v-3b013dda] .red-row{background-color:#f56c6c!important;color:#fff}.newForm[data-v-3b013dda]{margin-left:80px}.newForm .queryItem1[data-v-3b013dda]{width:60%;margin-top:20px}", ""]);
// Exports
module.exports = exports;
